import { useContext } from 'react'
import videoCallContext from '@features/panels/components/video-call/context/videocall.context'
import { useTheme } from '@features/theme/theme.hooks'
import { SxProps } from '@mui/material'
import { authApi, PublicUserProfile } from '@app/services'
import {
  BriefPublicUserProfile,
  useAuthGetReportedUsersQuery,
  useAuthUnreportUserMutation,
} from '@app/services/auto-generated/auth'
import { Button, Tooltip } from '@common/components'
import { useAppDispatch } from '@common/hooks'
import { FlagIcon, FlagOutlinedIcon } from '@common/icons'

const ReportUser = (props: {
  icon?: boolean
  userToReport?: PublicUserProfile | BriefPublicUserProfile
  lightColor?: string
  sx?: SxProps
}) => {
  const { isDark } = useTheme()
  const { icon, userToReport, lightColor = 'rgba(30,30,30,0.7)', sx } = props
  const dispatch = useAppDispatch()
  const { handleOpenReport } = useContext(videoCallContext)
  const [unReport] = useAuthUnreportUserMutation()
  const { data: listReport, isLoading } = useAuthGetReportedUsersQuery(undefined, {
    skip: !userToReport?.id,
  })

  const handleReport = async () => {
    if (userToReport) {
      const patchResult = dispatch(
        authApi.util.updateQueryData('authGetReportedUsers', undefined, (draft) => {
          if (draft?.includes(userToReport?.id)) {
            return (draft = draft?.filter((userId: number) => userId !== userToReport?.id))
          }
        }),
      )
      try {
        if (listReport?.includes(userToReport?.id)) {
          unReport({ userId: userToReport?.id as number }).unwrap()
        } else {
          handleOpenReport(userToReport)
        }
      } catch (error) {
        patchResult.undo()
        console.log(error)
      }
    }
  }
  return (
    <Tooltip title={listReport?.includes(userToReport?.id) ? 'Unreport' : 'Report'}>
      <Button
        disabled={isLoading}
        color={listReport?.includes(userToReport?.id) ? 'neutral' : 'error'}
        variant='outlined'
        onClick={handleReport}
        sx={{
          borderRadius: '15px',
          fontWeight: '600',
          width: icon ? 'unset' : '130px',
          minWidth: 'unset',
          borderColor: listReport?.includes(userToReport?.id)
            ? isDark
              ? 'white'
              : lightColor
            : 'error',
          color: listReport?.includes(userToReport?.id) ? (isDark ? 'white' : lightColor) : 'error',
          ...sx,
        }}
      >
        {listReport?.includes(userToReport?.id) ? (
          <>
            <FlagOutlinedIcon
              fontSize='small'
              sx={{ color: isDark ? 'white' : lightColor, mr: icon ? 0 : 0.5 }}
            />
            {!icon && 'Unreport'}
          </>
        ) : (
          <>
            <FlagIcon fontSize='small' sx={{ mr: icon ? 0 : 0.5 }} />
            {!icon && 'Report'}
          </>
        )}
      </Button>
    </Tooltip>
  )
}

export default ReportUser
